import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ConfigService } from '../config/config.service';
import { UserService } from '../shared/services/user.service';
import { SessionService } from '../shared/services/session.service';
import { Message } from 'primeng/primeng';
import { CommonDataService } from '../shared/services/common-data.service';

@Component({
    selector: 'app-forgotten-password',
    templateUrl: './forgotten-password.component.html',
    styleUrls: ['./forgotten-password.component.css']
})
export class ForgottenPasswordComponent implements OnInit {
    hideUI: boolean = false;
    recoverPassData: FormGroup;
    msg: Message[];
    submitted: boolean = false;
    successSendMail :boolean = false;

    messageEmail:string='Sent! You should receive an email shortly containing instructions to reset your password.';

    market: string;
    constructor(private commonDataService: CommonDataService,
        private userService: UserService,
        private sessionService: SessionService,
        private router: Router,
        private cd: ChangeDetectorRef,
        private configService: ConfigService) {
        this.recoverPassData = new FormGroup({
            'username': new FormControl('', Validators.required)
        });
    }

    ngOnInit() {
        /*'ve' === this.configService.market ? this.market = 'VENTURA_MARKET' :
            'sb' === this.configService.market ? this.market = 'SANTA_BARBARA_MARKET' : this.market = this.configService.market;*/

        // Settled on sending a template for SB market for "Member Forgot Password", considering that the WEB UI is divided to VE and SB
        // at the moment and there is no way of determining if the user has other than these markets specified for preferred.
        this.market = 'SANTA_BARBARA_MARKET';
    }

    validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }


    validarCampos() {
        if (!this.recoverPassData.get('username').valid) {
            this.msg.push({ severity: 'error', detail: 'Please enter a value for Email' });
         
        } else {

            if (!this.validateEmail(this.recoverPassData.value.username)) {
                this.msg.push({ severity: 'error', detail: 'Please enter a valid email address' });

            }
        }
    }


    onSubmit() {
        this.successSendMail = false;
        this.msg = [];
        this.submitted = true;
        let userData = this.commonDataService.deleteEmptyObjectProperties(this.commonDataService.trimObjectData(this.recoverPassData.value));


        this.validarCampos();

        if (this.recoverPassData.valid === false || this.msg.length > 0) {
            return;
        }


        this.hideUI = true;
        userData.username = userData.username.toLowerCase();
        let objToSend = {
            'market': this.market,
            'username': userData.username
        };

        this.userService.recoverFundraisingPassword(objToSend)
            .subscribe(
                data => {
                    this.hideUI = false;
                    this.successSendMail = true;
                    this.messageEmail ='Sent! You should receive an email shortly containing instructions to reset your password.';
                    this.cd.detectChanges();
                },
                error => {
                    if (error.parameterErrors != undefined) {
                        for (let i = 0; i < error.parameterErrors.length; i++) {
                            this.msg.push({ severity: 'error', detail: error.parameterErrors[i].message });
                        }
                    } else if (error.message.length != 0) {
                        if(error.code===22){
                            this.messageEmail = 'Sent!';
                            this.successSendMail = true;

                        }else{
                            this.msg.push({ severity: 'error', detail: error.message });
                        }                        
                    }
                    this.hideUI = false;
                    this.cd.detectChanges();
                }
            );

    }

}



// WEBPACK FOOTER //
// ./src/app/forgotten-password/forgotten-password.component.ts